import React from 'react';
import { FadeIn } from './FadeIn';
import { Cpu, Droplets, Shirt, PersonStanding } from 'lucide-react';
export function MicroReleaseMethod() {
  return <section className="w-full bg-dark py-24 border-b border-dark-lighter relative overflow-hidden" data-id="element-120">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-cyan-accent/5 rounded-full blur-[120px] pointer-events-none" data-id="element-121"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-122">
        <FadeIn data-id="element-123">
          <div className="text-center mb-12" data-id="element-124">
            <div className="inline-flex items-center justify-center p-4 bg-cyan-accent/10 border border-cyan-accent/30 rounded-full mb-6" data-id="element-125">
              <Cpu className="w-8 h-8 text-cyan-accent" data-id="element-126" />
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-bold uppercase mb-6" data-id="element-127">
              The <span className="text-cyan-accent" data-id="element-128">"Micro-Release"</span>{' '}
              Method
            </h2>
            <p className="text-2xl text-white font-light mb-8" data-id="element-129">
              A "Software Update" for Your Nervous System.
            </p>
            <p className="text-lg text-gray-300 leading-relaxed max-w-3xl mx-auto mb-12" data-id="element-130">
              Unlike traditional exercise, this protocol doesn't rely on forcing
              your body into submission. By performing specific 2-minute
              "nerve-glides" and "decompression hangs" right at your desk, you
              send an immediate signal to your brain to release the protective
              tension it’s been holding.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-131">
            <div className="bg-dark-panel border border-cyan-accent/20 p-6 flex flex-col items-center text-center" data-id="element-132">
              <Shirt className="w-8 h-8 text-cyan-accent mb-4" data-id="element-133" />
              <h3 className="font-display text-xl uppercase" data-id="element-134">
                No Clothes Change
              </h3>
            </div>
            <div className="bg-dark-panel border border-cyan-accent/20 p-6 flex flex-col items-center text-center" data-id="element-135">
              <Droplets className="w-8 h-8 text-cyan-accent mb-4" data-id="element-136" />
              <h3 className="font-display text-xl uppercase" data-id="element-137">No Sweating</h3>
            </div>
            <div className="bg-dark-panel border border-cyan-accent/20 p-6 flex flex-col items-center text-center" data-id="element-138">
              <PersonStanding className="w-8 h-8 text-cyan-accent mb-4" data-id="element-139" />
              <h3 className="font-display text-xl uppercase" data-id="element-140">
                No Standing Required
              </h3>
              <p className="text-sm text-gray-500 mt-2" data-id="element-141">(For most movements)</p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}